var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownRedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00104 0C6.21837 0 6.42237 0.106 6.54704 0.284667L11.2137 6.95133C11.3564 7.15467 11.3724 7.42067 11.259 7.64133C11.1437 7.862 10.9164 8 10.6677 8H1.33304C1.08437 8 0.857036 7.862 0.741703 7.64133C0.628369 7.42067 0.644369 7.15467 0.787036 6.95133L5.4537 0.284667C5.57837 0.106 5.78237 0 5.9997 0H6.00104Z",
    fill: "#D01A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownRedIcon);
export default __webpack_public_path__ + "static/media/down_red_icon.363436a23227cc7e175ad68ee2e2906b.svg";
export { ForwardRef as ReactComponent };